import $ from "cash-dom";

export default (function () {
    $(document).ready(function () {
        var selector = ".menu-toggle";

        if ($(selector).length) {
            var log = typeof debug !== "undefined";
            if (log) console.log("%cfunction_menu-button.js initialized", "color: green;");

            $(selector).on("click", function (_e) {
                var instance = $(this);
                var navigation = $("#menu");

                console.log(_e.target);

                instance.toggleClass("on");
                navigation.toggleClass("on");
            });
        }
    });
})();
